export const getFilters = state => {
  return state.pages.investor.list.filters;
};

export const getNextUrl = state => {
  return state.pages.investor.list.nextUrl;
};
